import React from 'react';
import { Handle, Position } from 'reactflow';
import { Check } from 'lucide-react';
import './NodeStyles.css';

const EndNode = ({ data, selected }) => {
  const badge = data?.wfBadge; // e.g., { code:'E011', title:'Non-terminating path' }
  return (
    <div className={`end-node ${selected ? 'selected' : ''}`} title={data?.wfTooltip}>
      <Handle type="target" position={Position.Top} className="node-handle node-handle-top" />
      <div className="term-badge">
        <Check size={16} strokeWidth={2.5} />
      </div>
      <span className="term-label">End</span>
      {badge && (
        <div
          className="wf-badge"
          title={badge.title || badge.code}
          style={{ marginLeft: 8, display: 'inline-block', padding: '2px 6px', borderRadius: 10, border: '1px solid #dc3545', background: '#f8d7da', color: '#333', fontSize: 11 }}
        >
          {badge.code}
        </div>
      )}
    </div>
  );
};

export default EndNode;
